// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"38":"2ad616d9","453":"7156844e","667":"795e9827","977":"13a9f9eb"}[chunkId] + ".chunk.js";
};